export const slideInOut = (intensity: number = 100) =>
  ({
    initial: {
      opacity: 0,
      y: `-${intensity}%`
    },
    animate: { opacity: 1, y: 0 },
    exit: {
      opacity: 0,
      y: `${intensity}%`,
      transition: { duration: 0.2 }
    },
    transition: {
      type: 'spring',
      damping: 15,
      mass: (0.5 * intensity) / 100
    }
  }) as const;
